import './storeLogo.scss';

export const StoreLogo = angular
    .module('checkout.components.storeLogo', [])
    .component('storeLogo', {
        template: `
            <a ng-href="{{$ctrl.linkUrl}}" class="store-logo">
                <img ng-if="$ctrl.logo" ng-src="{{$ctrl.logo}}" class="store-logo__image" />
                <span ng-if="$ctrl.storeName" class="store-logo__name">{{$ctrl.storeName}}</span>
            </a>
        `,
        bindings: {
            storeInfo: '<',
            linkUrl: '<'
        },
        controller: class StoreLogoCtrl {
            $onInit() {
                if (this.storeInfo
                    && this.storeInfo.logo
                    && this.storeInfo.logo.imageLink
                    && this.storeInfo.logo.imageLink.fullUri) {
                    this.logo = this.storeInfo.logo.imageLink.fullUri;
                } else {
                    this.storeName = this.storeInfo.name;
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/storeLogo/storeLogo.js